<div class="notification-container">
    <img src="../../../assets/icons/notification_bell.svg" alt="bell_icon">
    <div class="notification-number">
        {{notificationCount}}
    </div>
</div>